import styled, { css } from 'styled-components';
import { theme, palette } from 'styled-tools';
import { Label } from 'components';

export const FeatureContainer = styled.div`
    width: 100%;
`;

export const FeatureOptionRow = styled.div`
    display: flex;
    border-bottom: 1px solid ${palette('gray_opacity_100')};
`;

export const FeatureContentsRow = styled.div`
    display: flex;
    &:not(:last-child) {
        ${props => {
        return css`${FeatureContentsWrapper} {border-bottom: 1px solid ${palette('gray_opacity_100')};}`;
    }}
    }
`;

export const FeatureContentsWrapper = styled.div`
    display: flex;
    width: 75%;
`;

export const ItemCell = styled.div`
    width: 25%;
    padding: 12px 20px;
    display: flex;
    align-items: center;
`;

export const CenterOptionItemCell = styled.div`
    width: 100%;
    padding: 12px 20px 20px 20px;
    display: flex;
    justify-content: center;
    text-align: center;
    white-space: nowrap;
`;

export const CenterContentItemCell = styled.div`
    width: 100%;
    padding: 24px 0;
    display: flex;
    justify-content: center;
    text-align: center;
`;

export const FeatureStyleLabel = styled(Label)`
    color: ${palette('gray_opacity_800')};
    ${theme('fontStyle.body2')};
`;